export default {"src":"/_next/static/image/public/images/ic_order_credit_card.c066f1c15f1c272b79854a07c598f441.svg","height":19,"width":26};